'use client';

/**
 * Plan Commercial Position KPI card shells — three thin cards slicing
 * usePlanCommercialView, each rendering CoverageKpiTile. Same
 * composite-payload convention as analytics/kpi-cards.tsx: one shared
 * hook, N thin card shells, React Query dedupes to one BFF call.
 *
 *   Decided spend  ← plan_total_decided (hero)
 *   Decided lines  ← decided_line_count
 *   Vendors        ← vendors.length
 *
 * @arch_component_type widget
 * @arch_domain canvas
 */

import { DollarSign, ListChecks, Building2 } from 'lucide-react';
import { CoverageKpiTile } from '../../analytics/kpi-tile';
import { usePlanCommercialView, PLAN_KPI_LOADING } from './use-plan-commercial-view';

export function ObeyaPlanCommercialKpiSpendCard() {
  const { data, queryKey } = usePlanCommercialView();
  const value = data ? `$${data.plan_total_decided.toLocaleString()}` : PLAN_KPI_LOADING;
  const sub = data ? (data.basis === 'live' ? 'live' : 'tagged Rev') : undefined;
  return (
    <CoverageKpiTile
      label="Decided spend"
      Icon={DollarSign}
      value={value}
      sub={sub}
      accent
      contentKey="obeya_plan_commercial_kpi_spend"
      queryKey={queryKey}
    />
  );
}

export function ObeyaPlanCommercialKpiLinesCard() {
  const { data, queryKey } = usePlanCommercialView();
  return (
    <CoverageKpiTile
      label="Decided lines"
      Icon={ListChecks}
      value={data ? data.decided_line_count.toLocaleString() : PLAN_KPI_LOADING}
      contentKey="obeya_plan_commercial_kpi_lines"
      queryKey={queryKey}
    />
  );
}

export function ObeyaPlanCommercialKpiVendorsCard() {
  const { data, queryKey } = usePlanCommercialView();
  return (
    <CoverageKpiTile
      label="Vendors in the decided set"
      Icon={Building2}
      value={data ? data.vendors.length.toLocaleString() : PLAN_KPI_LOADING}
      contentKey="obeya_plan_commercial_kpi_vendors"
      queryKey={queryKey}
    />
  );
}
